<template>
  <div class="col-body">
    <div class="col col-main">
      <job-detail :job="job" />
      <job-company v-if="job.company" :company="job.company" />
      <job-actions :job="job" />
      <span class="ja__bg" />
    </div>
    <div class="col col-related">
      <job-company v-if="job.company" :company="job.company" />
      <job-related
        v-if="showRelatedLists"
        :company-jobs="companyJobs"
        :bidding-id="biddingId"
        :bidding-session="biddingSession"
        :company-jobs-total="companyJobsTotal"
        :request-id="requestId"
        :tracking-params="trackingParams"
        :related-jobs="relatedJobs"
        :related-jobs-total="relatedJobsTotal"
        :related-job-session-id="session.related"
        :related-jobs-without-ads-total="relatedJobsWithoutAdsTotal"
        :company-session-id="session.company"
        @related-jobs-loading="onRelatedJobsLoading"
      />
    </div>
  </div>
</template>

<script>
import JobActions from './jobActions'
import JobCompany from './jobCompany/jobCompany'
import JobDetail from './jobDetail/jobDetail'
import JobRelated from './jobRelated/jobRelated'

export default {
  components: {
    'job-actions': JobActions,
    'job-company': JobCompany,
    'job-detail': JobDetail,
    'job-related': JobRelated,
  },
  computed: {
    showRelatedLists() {
      return this.relatedJobs.length > 0 || this.companyJobs.length > 0
    },
  },
  methods: {
    onRelatedJobsLoading(tab) {
      this.$emit('related-jobs-wrapper-loading', tab)
    },
  },
  props: {
    biddingId: {
      default: '',
      type: String,
    },
    biddingSession: {
      default: '',
      type: String,
    },
    companyJobs: {
      default: () => [],
      type: Array,
    },
    companyJobsTotal: {
      required: true,
      type: Number,
    },
    job: {
      required: true,
      type: Object,
    },
    relatedJobs: {
      default: () => [],
      type: Array,
    },
    relatedJobsTotal: {
      required: true,
      type: Number,
    },
    relatedJobsWithoutAdsTotal: {
      required: true,
      type: Number,
    },
    requestId: {
      default: '',
      type: String,
    },
    session: {
      default: () => ({}),
      type: Object,
    },
    trackingParams: {
      default: () => ({}),
      type: Object,
    },
  },
}
</script>

<style lang="postcss" scoped>
.col--bdc.bcb {
  @apply w-px;
}

.ja {
  @apply -mt-3;
}
.ja__bg {
  @apply block w-full h-ja mt-ja mb-3 bg-white z-0;
}

>>> .jd-section {
  @apply mb-3 px-3 py-4 bg-white;

  & h2 {
    @apply mb-3;
  }
}

>>> .jd-section__items {
  & .jd-section__item--fixed-width {
    max-width: 400px;
  }
  & .jd-section__item:not(:first-child) {
    @apply mt-4;
  }
  & .jd-section__item.jd-section__item--sm:not(:first-child) {
    @apply mt-2;
  }
}

>>> .jr {
  @apply -mt-1;
}

>>> .jd-section .job-section__header {
  @apply mb-3 text-17/4 font-medium;
}

@screen mobile {
  .col-related .jd-company {
    @apply hidden;
  }
  .col--bdc {
    @apply bg-white;
  }
}

@screen desktop {
  .col-body {
    @apply flex;
  }
  .col-main {
    @apply flex-grow min-w-0;
  }
  .col-related {
    @apply flex-shrink-0 ml-4;
    width: 336px;
  }
  .col-main .jd-company {
    @apply hidden;
  }

  .ja {
    @apply -mt-4;
  }
  .ja__bg {
    @apply h-ja-desktop mt-ja-desktop;
  }

  >>> .jd-section {
    @apply mb-4 px-4 py-6;
  }
  >>> .jd-section h2,
  >>> .jd-section .job-section__header {
    @apply mb-6 text-xl font-bold;
  }

  >>> .jd-section__items .jd-section__item:not(:first-child) {
    @apply mt-5;
  }
  >>> .jd-section__items .jd-section__item.jd-section__item--sm:not(:first-child) {
    @apply mt-3;
  }
}
</style>
